<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        h5.title {{ config.title }}
        p {{ config.content }}
        br
        .columns
          .column
            .level-right
              .field.is-grouped
                p.control
                  a.button.is-rounded(:class="config.classCancel" @click="changeEstado(false)")
                    | {{ config.textCancel }}
                p.control
                  a.button.is-rounded(:class="config.classOk" @click="changeEstado(true)")
                    | {{ config.textOk }}
</template>

<script>
  export default {
    name: 'ModalEstado',
    props: {
      config: {
        type: Object,
        default: ()=> {}
      }
    },
    data() {
      return {
        isSelected: false
      }
    },
    watch: {
      actual() {
        this.isSelected = this.actual
      }
    },
    methods: {
      cerrarModal () {
        this.$emit('padre:select', 'close')
      },
      changeEstado (res) {
        this.$emit('padre:select', res)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/shared/ModalEstado.vue